import { render, staticRenderFns } from "./IcoContentInPortal.vue?vue&type=template&id=bd3bcbf6"
import script from "./IcoContentInPortal.vue?vue&type=script&lang=js"
export * from "./IcoContentInPortal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports